import { generateHash } from "modules/chart-builder/utils/generateHash"
import { postStateConfig } from "modules/state-config/actions/postStateConfig"
import { useRouter } from "next/router"
import type { CustomChartConfigPayload } from "modules/chart-builder/types"

/**
 * Hook to generate and navigate to studio chart URLs
 *
 * @example
 * const studioLink = useStudioLink()
 *
 * // Navigate to studio with chart config
 * studioLink({
 *   zoom: "30d",
 *   title: "Revenue over time",
 *   configs: [{
 *     id: "revenue-chart",
 *     yAxis: "left",
 *     title: "Revenue",
 *     colors: [],
 *     metric: "revenue",
 *     display: null,
 *     filters: [{
 *       type: "project",
 *       values: ["project-id"],
 *       comparator: "in"
 *     }],
 *     groupBy: "project",
 *     projects: [],
 *     chart_type: "bar-unstacked"
 *   }],
 *   show_table: false,
 *   show_title: true,
 *   description: null,
 *   granularity: "day",
 *   show_description: false,
 *   show_current_period: true
 * })
 */

export function useStudioLink(newTab = true) {
  const router = useRouter()

  return async (config: CustomChartConfigPayload) => {
    const hash = await generateHash(config)
    await postStateConfig(config, "chart")

    if (newTab) {
      window.open(`/explorer/studio/charts/new?v=${hash}`, "_blank")
    } else {
      router.push(`/studio/charts/new?v=${hash}`)
    }
  }
}
